module.exports = __webpack_public_path__ + "static/media/brainflix-combined-2-ipad.79fd95d6.png";